import FeaturedSolutions from "../../../components/FeaturedSolutions";
import HorizontalLine from "../../../components/icons/HorizontalLine";
import LogoMini from "../../../components/icons/LogoMini";
import InfoGenesis from "../../../assets/img/Featured/tablet-info-genesis.png";
import IGOnDemand from "../../../assets/img/Featured/app-ondemand-food.png";
import IGKiosk from "../../../assets/img/Featured/kiosk-food-order-tall.png";
import DigitalMenu from "../../../assets/img/Featured/digital-menu.png";
import Loyalty from "../../../assets/img/Featured/app-rewards.png";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useCallback } from "react";
import { useData } from "../../../context/DataProvider";
import { Header } from "../../../components/Header";

const CafePage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const navigate = useNavigate();
    return (
      <div className="page cafePage">
        <Header />
        <div className="page-header">Healthcare Dining</div>
        <div className="text-wrapper">
          <div className="top">
            <div className="topic-header">Café</div>
            <HorizontalLine />
          </div>
          <div className="std-text">
            Healthcare dining must balance patient well-being with 
            operational realities. Personalized meal ordering systems honor 
            dietary needs and physician-directed diets, while self-service 
            options provide staff and families with convenient access during 
            demanding shifts.{'\n\n'}

            Advanced reporting reveals patterns in waste, inventory and 
            throughput, equipping operators to reduce costs and improve 
            satisfaction, creating a more resilient and patient-centered food 
            service environment.
          </div>
        </div>

        <FeaturedSolutions>
          <div
            className="featured-item"
            onClick={() => {
              _logEvent("click", "Healthcare Dining - Cafe", "InfoGenesis");
              addFlow("InfoGenesis");
              navigate("/solutions/info-genesis");
            }}
          >
            <div className="item-head">
              <LogoMini />
              InfoGenesis
            </div>
            <img src={InfoGenesis} alt="" />
          </div>
          <div
            className="featured-item"
            onClick={() => {
              _logEvent("click", "Healthcare Dining - Cafe", "IG OnDemand");
              addFlow("IG OnDemand");
              navigate("/solutions/ig-on-demand");
            }}
          >
            <div className="item-head">
              <LogoMini />
              IG OnDemand
            </div>
            <img src={IGOnDemand} alt="" />
          </div>
          <div
            className="featured-item"
            onClick={() => {
              _logEvent("click", "Healthcare Dining - Cafe", "IG Kiosk");
              addFlow("IG Kiosk");
              navigate("/solutions/ig-kiosk");
            }}
          >
            <div className="item-head">
              <LogoMini />
              IG Kiosk
            </div>
            <img src={IGKiosk} alt="" />
          </div>
          <div
            className="featured-item"
            onClick={() => {
              _logEvent("click", "Healthcare Dining - Cafe", "IG Digital Menu Board");
              addFlow("IG Digital Menu Board");
              navigate("/solutions/digital-menu");
            }}
          >
            <div className="item-head">
              <LogoMini />
              IG Digital Menu Board
            </div>
            <img src={DigitalMenu} alt="" />
          </div>
          <div
            className="featured-item"
            onClick={() => {
              _logEvent("click", "Healthcare Dining - Cafe", "Loyalty & Promotions");
              addFlow("Loyalty & Promotions");
              navigate("/solutions/loyalty");
            }}
          >
            <div className="item-head">
              <LogoMini />
              Loyalty & Promotions
            </div>
            <img src={Loyalty} alt="" />
          </div>
        </FeaturedSolutions>
      </div>
    );
}
export default CafePage;